import { render, staticRenderFns } from "./WiaaCertificationSearch.vue?vue&type=template&id=45f39e17&scoped=true&"
import script from "./WiaaCertificationSearch.vue?vue&type=script&lang=js&"
export * from "./WiaaCertificationSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f39e17",
  null
  
)

export default component.exports